<template>
    <div>
        <FormDialog :title="title" :isShow.sync="isShow" width="944px" v-on:resetForm="close()">
            <div class="home land-form">
                <el-form ref="form" :model="form" :rules="rules" size="small">
                    <table>
                        <tbody>
                        <tr>
                            <td class="header" colspan="4">基本信息</td>
                        </tr>
                        <tr>
                            <td><span v-show="editFlag" style="color:red;">*</span>地块名称</td>
                            <td colspan="3">
                                <el-form-item v-show="editFlag" prop="dkmc">
                                    <el-input v-model="form.dkmc"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.dkmc}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><span v-show="editFlag" style="color:red;">*</span>地块位置</td>
                            <td colspan="3">
                                <el-form-item v-show="editFlag" prop="dkdz">
                                    <el-input v-model="form.dkdz"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.dkdz}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 20%;"><span v-show="editFlag" style="color:red;">*</span>地块面积</td>
                            <td style="width: 30%;">
                                <el-form-item v-show="editFlag" prop="dkmj">
                                    <el-input v-model="form.dkmj">
                                        <template slot="append">亩</template>
                                    </el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.dkmj}}亩</span>
                            </td>
                            <td style="width: 20%;"><span v-show="editFlag" style="color:red;">*</span>行政区</td>
                            <td style="width: 30%;">
                                <el-form-item v-show="editFlag" prop="xzqmc">
                                    <!--                                        <pf-select :api="item.api" :prop="item.prop" :filterable="item.filterable" :options="item.options" v-model="data[item.prop]"></pf-select>-->
                                    <el-select v-model="form.xzqmc">
                                        <el-option  v-for="(item,index) in xzqArray" v-bind:value="item.label" v-text="item.label" :command="item" :key="'header'+ index"></el-option>
                                    </el-select>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.xzqmc}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><span v-show="editFlag" style="color:red;">*</span>用地性质</td>
                            <td>
                                <el-form-item v-show="editFlag" prop="ydxz" >
                                    <!--                                        <pf-select :api="item.api" :prop="item.prop" :filterable="item.filterable" :options="item.options" v-model="data[item.prop]"></pf-select>-->
                                    <el-select v-model="form.ydxz">
                                        <el-option label="住宅用地" value="1"></el-option>
                                        <el-option label="商业用地" value="2"></el-option>
                                        <el-option label="工业用地" value="3"></el-option>
                                        <el-option label="其他" value="4"></el-option>
                                    </el-select>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.ydxz}}</span>
                            </td>
                            <td><span v-show="editFlag" style="color:red;">*</span>土地用途</td>
                            <td>
                                <el-form-item v-show="editFlag" prop="tdyt">
                                    <el-input v-model="form.tdyt"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.tdyt}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>供地方式</td>
                            <td>
                                <el-form-item v-show="editFlag" prop="gdfs">
                                    <el-input v-model="form.gdfs"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.gdfs}}</span>
                            </td>
                              <td>供地时间</td>
                            <td>
                                <el-form-item v-show="editFlag">
                                    <el-date-picker
                                            v-model="form.gdsj"
                                            type="date"
                                            placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.gdDate}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>开发程度</td>
                            <td>
                                <el-form-item v-show="editFlag"  prop="kfcd">
                                    <el-input v-model="form.kfcd"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.kfcd}}</span>
                            </td>
                            <td><span v-show="editFlag" style="color:red;">*</span>容积率</td>
                            <td>
                                <el-form-item v-show="editFlag" prop="rjl">
                                    <el-input v-model="form.rjl"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.rjl}}</span>
                            </td>

                        </tr>
                        <tr>
                             <td>会审状态</td>
                            <td>
                                <el-form-item v-show="editFlag">
                                     <el-select v-model="form.ghzt">
                                        <el-option label="已过会" value="0"></el-option>
                                        <el-option label="未过会" value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.ghzt == '1'?'未过会': '已过会'}}</span>
                            </td>
                            <td>会审时间</td>
                            <td>
                                <el-form-item v-show="editFlag">
                                    <el-date-picker
                                            v-model="form.ghsj"
                                            type="date"
                                            placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.ghDate}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>招商联系人</td>
                            <td>
                                <el-form-item  prop="lxr">
                                    <el-input v-show="editFlag" v-model="form.lxr"></el-input>
                                    <span v-show="!editFlag">{{form.lxr}}</span>
                                </el-form-item>
                            </td>
                            <td>招商联系电话</td>
                            <td>
                                <el-form-item v-show="editFlag"  prop="lxdh">
                                    <el-input v-model="form.lxdh"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.lxdh}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>推介说明</td>
                            <td colspan="3">
                                <el-form-item v-show="editFlag"  prop="tjsm">
                                    <el-input type="textarea" v-model="form.tjsm"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.tjsm}}</span>
                            </td>
                        </tr>
                         <tr>
                            <td>全景图拍摄时间</td>
                            <td>
                                <el-form-item v-show="editFlag">
                                    <el-date-picker
                                            v-model="form.qjtpssj"
                                            type="date"
                                            placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.qjtpsDate}}</span>
                            </td>
                             <td></td>
                             <td>
                             </td>
                        </tr>
                         <tr>
                            <td>全景图</td>
                            <td colspan="3">

                                <el-form-item >
                                    <div v-if="showEiteButton" style="margin-bottom: 10px;">
                                        <el-button size="small" type="primary" @click="plottinghandler">
                                            <i class="iconfont icon-dingwei1"></i>
                                            <span>全景图标会</span>
                                        </el-button>
                                    </div>
                                    <div class="add-img" v-show="editFlag">
                                        <pf-file-upload
                                                v-model="qjtUploadList"
                                                :isLimit="false"
                                                :actionUrl="qjtUrl"
                                                :listType="'picture'"
                                                :drag="true"
                                                @handleChangeLimit="handleChangeLimit"
                                                accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG">
                                        </pf-file-upload>
                                    </div>
                                    <div v-show="!qjtShow&&!editFlag"  style="width: 100%;
                                  height: 300px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  background: #F2F5F6;
                                  border-radius: 4px; ">
                                      <i style="  color: #D0DCE5;  font-size: 56px; text-align: center;" class="iconfont icon-zanwutupian"></i>
                                  </div>
                                  <photosphereviewer  v-if="!editFlag&&showViewer&&qjtShow"  :tableImgHeight="'290px'" :landinfo ="landinfo" ></photosphereviewer>
                                </el-form-item>
                            </td>
                        </tr>
                        <tr>
                            <td>地块范围</td>
                            <td colspan="3">
                                <el-form-item>
                                   <div style="margin-bottom: 10px;" v-show="editFlag">
                                        <el-button size="small" type="primary" @click="importhandler">
                                            <i class="iconfont icon-dingwei1"></i>
                                            <span>导入</span>
                                        </el-button>
                                        <el-button size="small" type="primary" @click="positonhandler">
                                            <i class="iconfont icon-dingwei1"></i>
                                            <span>定位</span>
                                        </el-button>
                                    </div>
                                    <div style="width:100%;height: 400px;">
                                        <vimportmap @ready="readyHandler"></vimportmap>
                                    </div>
                                </el-form-item>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4" class="header">规划条件</td>
                        </tr>
                        <tr>
                            <td>绿化率</td>
                            <td>
                                <el-form-item v-show="editFlag"  prop="lhl">
                                    <el-input v-model="form.lhl"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.lhl}}</span>
                            </td>
                             <td>建筑密度</td>
                            <td>
                                <el-form-item v-show="editFlag"  prop="jzmd">
                                    <el-input v-model="form.jzmd"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.jzmd}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>出让年限</td>
                            <td>
                                <el-form-item v-show="editFlag"  prop="crnx">
                                    <el-input v-model="form.crnx"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.crnx}}</span>
                            </td>
                            <td>建筑限高</td>
                            <td>
                                <el-form-item v-show="editFlag"  prop="jzxg">
                                    <el-input v-model="form.jzxg">
                                        <template slot="append">米</template>
                                    </el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.jzxg}}米</span>
                            </td>
                        </tr>
                         <tr>
                            <td>其他规划条件</td>
                            <td colspan="3">
                                <el-form-item v-show="editFlag"  prop="qt">
                                    <div>
                                        <el-input type="textarea" v-model="form.qt"></el-input>
                                    </div>
                                    <div v-show="editFlag" class="qt-upload" style="margin-top: 10px;">
                                        <pf-file-upload
                                                v-model="ghfjUploadList"
                                                :actionUrl="ghfjUrl"
                                                :listType="'text'"
                                                :isLimit="false"
                                                accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG">
                                        </pf-file-upload>
                                    </div>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.qt}}</span>
                            </td>
                        </tr>
                         <tr>
                            <td>社区配套</td>
                            <td colspan="3">
                                <el-form-item v-show="editFlag"  prop="sqpt">
                                    <div>
                                        <el-input type="textarea" v-model="form.sqpt"></el-input>
                                    </div>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.sqpt}}</span>
                            </td>
                        </tr>
                         <tr>
                            <td>养老配套</td>
                            <td colspan="3">
                                <el-form-item v-show="editFlag"  prop="ylpt">
                                    <div>
                                        <el-input type="textarea" v-model="form.ylpt"></el-input>
                                    </div>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.ylpt}}</span>
                            </td>
                        </tr>
                         <tr>
                            <td>教育配套</td>
                            <td colspan="3">
                                <el-form-item v-show="editFlag"  prop="jypt">
                                    <div>
                                        <el-input type="textarea" v-model="form.jypt"></el-input>
                                    </div>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.jypt}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>其他规划配套</td>
                            <td colspan="3">
                                <el-form-item v-show="editFlag"  prop="qtpt">
                                    <div>
                                        <el-input type="textarea" v-model="form.qtpt"></el-input>
                                    </div>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.qtpt}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4" class="header">评估信息</td>
                        </tr>
                        <tr>
                            <td style="width: 20%;">评估总价</td>
                            <td style="width: 30%;">
                                <el-form-item v-show="editFlag"  prop="pgzj">
                                    <el-input v-model="form.pgzj">
                                        <template slot="append">万元</template>
                                    </el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.pgzj}}万元</span>
                            </td>
                            <td style="width: 20%;">评估亩均价</td>
                            <td style="width: 30%;">
                                <el-form-item v-show="editFlag"  prop="pgmjj">
                                    <el-input v-model="form.pgmjj">
                                        <template slot="append">万元</template>
                                    </el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.pgmjj}}万元</span>
                            </td>
                        </tr>
                         <tr>
                            <td style="width: 20%;">评估楼面地价</td>
                            <td style="width: 30%;">
                                <el-form-item v-show="editFlag"  prop="pglmdj">
                                    <el-input v-model="form.pglmdj">
                                        <template slot="append">元/㎡</template>
                                    </el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.pglmdj}}元/㎡</span>
                            </td>
                             <td style="width: 20%;"></td>
                             <td style="width: 30%;">
                             </td>
                        </tr>

                        <tr>
                            <td colspan="4" class="header">出让信息</td>
                        </tr>
                        <tr>
                            <td>地块编号</td>
                            <td colspan="3">
                                <el-form-item v-show="editFlag"  prop="dkbh">
                                    <el-input v-model="form.dkbh"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.dkbh}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 20%;">成交价(万元)</td>
                            <td style="width: 30%;">
                                <el-form-item v-show="editFlag"  prop="cjj">
                                    <el-input v-model="form.cjj">
                                        <template slot="append"></template>
                                    </el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.cjj}}万元</span>
                            </td>
                            <td style="width: 20%;">出让状态</td>
                            <td style="width: 30%;">
                                <el-form-item v-show="editFlag">
                                    <el-select v-model="form.crzt">
                                        <el-option label="未出让" value="0"></el-option>
                                        <el-option label="已出让" value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.crzt=="1" ? "已出让" : "未出让"}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>竞得人</td>
                            <td>
                                <el-form-item v-show="editFlag"  prop="jdr">
                                    <el-input v-model="form.jdr"></el-input>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.jdr}}</span>
                            </td>
                            <td>成交日期</td>
                            <td>
                                <el-form-item v-show="editFlag">
                                    <el-date-picker
                                            v-model="form.jdrq"
                                            type="date"
                                            placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <span v-show="!editFlag">{{form.jdDate}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4" style="border: none;background: transparent;padding: 10px;"></td>
                        </tr>
                        <tr>
                            <td colspan="4" class="header">周边配套</td>
                        </tr>
                        <tr>
                            <td class="last-td" colspan="4" style="padding: 0px;background: transparent;">
                                <div class="tabs">
                                    <div class="tabs-label">
                                        <div :style="'width:calc(100% / '+ all.length +')'"
                                             v-for="(item, index) in all" :key="'all'+index"
                                             @click="tabsClick(item)" :class="tabsActive === item.id? 'active': ''"
                                             v-html="item.type"></div>
                                    </div>
                                    <div class="tabs-content">
                                        <div>
                                            <el-button v-show="editFlag" @click="analysis()" size="small" type="primary">
                                                <i class="iconfont icon-fenxi"></i>
                                                <span>分析</span>
                                            </el-button>
                                        </div>
                                        <div>
                                            <table>
                                                <tbody>
                                                <tr>
                                                    <th style="width: 20%;">序号</th>
                                                    <th style="width: 80%;">名称</th>
                                                </tr>
                                                <tr v-for="(item, index) in tableList" :key="'tableList'+index">
                                                    <td v-html="index+1"></td>
                                                    <td v-html="'距' + item.name + item.distance + '米'"></td>
                                                    <td><el-button v-show="editFlag" type="primary" @click="deletefxjg_linshi(index)" size="small">删除</el-button></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </el-form>
            </div>
            <template v-slot:footer>
                <el-button v-show="tjShow" type="primary" @click="tjsubmit()" size="small">提交</el-button>
                <el-button v-show="fbShow" type="primary" @click="fbsubmit()" size="small">发布</el-button>
                <el-button v-show="xjShow" type="primary" @click="xjsubmit()" size="small">下架</el-button>
                <el-button v-show="bcShow" type="primary" @click="submit()" size="small">保存</el-button>
                <el-button @click="isShow=false" size="small">关闭</el-button>
            </template>
        </FormDialog>
        <FormDialog title="导入地块坐标" :isShow.sync="showImportmap" v-if="showImportmap" width="944px" height="600px" v-on:resetForm="importMapClose()">
            <div style="width: 100%; height: 500px;">
               <vimportFilemap ref="myimportmap"></vimportFilemap>
            </div>
            <template v-slot:footer>
                <el-button type="primary" @click="vimportFilemapSubmit()" size="small">确定</el-button>
                <el-button @click="showImportmap=false" size="small">取消</el-button>
            </template>
        </FormDialog>
        <FormDialog title="标会全景图坐标" :isShow.sync="panoramicViewShow" v-if="panoramicViewShow" width="100%" height="100%" v-on:resetForm="importMapClose()">
            <div style="width: 100%; height: 100%;">
                  <plot ref="plotpanora" :landinfo ="landinfo"></plot>
            </div>
            <template v-slot:footer>
                <el-button type="primary" @click="plotSubmit()" size="small">保存</el-button>
                <el-button @click="panoramicViewShow=false" size="small">取消</el-button>
            </template>
        </FormDialog>
    </div>
</template>
<script>
import vimportmap from 'components/main-map/import-map'
import FormDialog from '@/components/dialog/formDialog'
import {mapResourceApi} from '@/api/mapResourceApi'

import {coordinatesconvert} from '@/views/class/coordinatesconvert'
import {mapmanager, xzqUtils} from '@/views/class/mapmanager'
import {mapsearcharound} from '@/views/class/mapsearcharound'
import vimportFilemap from './importFilemap.vue'
import plot from './plot.vue'
import photosphereviewer from 'components/main-map/photosphereviewer'
import { landinifoApi } from '@/api/managementSystemApi'
import { Notification } from 'element-ui'
import * as turf from '@turf/turf'
export default {
  name: 'edit',
  components: {
    photosphereviewer,
    FormDialog,
    vimportmap,
    vimportFilemap,
    plot
  },
  data() {
    return {
      map: null,
      showImportmap: false,
      xzqArray: [],
      isShow: false,
      fbShow: false,
      tjShow: false,
      xjShow: false,
      bcShow: true,
      title: '新增',
      landinfo: {},
      form: {},
      rules: {
        dkmc: [{ required: true, message: '请输入地块名称', trigger: 'blur' },
          { validator: this.$validRule.validChinese, trigger: 'blur' }],
        dkdz: [{ required: true, message: '请输入地块位置', trigger: 'blur' },
          { validator: this.$validRule.validChinese, trigger: 'blur' }],
        gdfs: [{ validator: this.$validRule.validHanzi, trigger: 'blur' }],
        kfcd: [{ validator: this.$validRule.validChinese, trigger: 'blur' }],
        lxr: [{ validator: this.$validRule.validHanzi, trigger: 'blur' }],
        lxdh: [{ validator: this.$validRule.checkMobile, trigger: 'blur' }],
        tjsm: [{ validator: this.$validRule.validChinese, trigger: 'blur' }],
        lhl: [{ validator: this.$validRule.validChinese, trigger: 'blur' }],
        jzmd: [{ validator: this.$validRule.validChinese, trigger: 'blur' }],
        crnx: [{ validator: this.$validRule.validHanzi, trigger: 'blur' }],
        jzxg: [{ validator: this.$validRule.validHanzi, trigger: 'blur' }],
        qt: [{ validator: this.$validRule.validChinese, trigger: 'blur' }],
        sqpt: [{ validator: this.$validRule.validChinese, trigger: 'blur' }],
        ylpt: [{ validator: this.$validRule.validChinese, trigger: 'blur' }],
        jypt: [{ validator: this.$validRule.validChinese, trigger: 'blur' }],
        qtpt: [{ validator: this.$validRule.validChinese, trigger: 'blur' }],
        pgzj: [{ validator: this.$validRule.validNumber, trigger: 'blur' },
          { validator: this.$validRule.validPositiveNumber, trigger: 'blur' }],
        pgmjj: [{ validator: this.$validRule.validNumber, trigger: 'blur' },
          { validator: this.$validRule.validPositiveNumber, trigger: 'blur' }],
        pglmdj: [{ validator: this.$validRule.validNumber, trigger: 'blur' },
          { validator: this.$validRule.validPositiveNumber, trigger: 'blur' }],
        dkbh: [{ validator: this.$validRule.validHanzi, trigger: 'blur' }],
        cjj: [{ validator: this.$validRule.validNumber, trigger: 'blur' },
          { validator: this.$validRule.validPositiveNumber, trigger: 'blur' },
          { validator: this.$validRule.validzifu, trigger: 'blur' }],
        jdr: [{ validator: this.$validRule.validHanzi, trigger: 'blur' }],
        xzqmc: [{ required: true, message: '请选择地块所在行政区', trigger: 'change' }],
        ydxz: [{ required: true, message: '请选择用地性质', trigger: 'change' }],
        dkmj: [{ required: true, message: '请输入地块面积', trigger: 'blur' },
          { validator: this.$validRule.validNumber, trigger: 'blur' },
          { validator: this.$validRule.validPositiveNumber, trigger: 'blur' },
          { validator: this.$validRule.validzifu, trigger: 'blur' }
        ],
        tdyt: [{ required: true, message: '请输入土地用途', trigger: 'blur' },
          { validator: this.$validRule.validHanzi, trigger: 'blur' }],
        rjl: [{ required: true, message: '请输入容积率', trigger: 'blur' },
          { validator: this.$validRule.validChinese, trigger: 'blur' }]
      },
      qjtUploadList: [],
      ghfjUploadList: [],
      ghfjUrl: '/openApi/uploadFile/uploadAttachment',
      qjtUrl: '/openApi/uploadFile/uploadQJT',
      tabsActive: '',
      buttonStyle: {
        size: 'small',
        type: 'primary',
        plain: false,
        round: false,
        icon: 'iconfont icon-shangchuan',
        name: '上传'
      },
      tableList: [],
      all: [],
      editFlag: false,
      panoramicViewShow: false,
      qjtShow: false,
      showViewer: false,
      showEiteButton: false
    }
  },
  beforeCreate() {

  },
  created() {
    // this.showEiteButton = `${showEiteButton}`
    console.log(`${showimgButton}`)
    if (`${showimgButton}` == 'false') {
      console.log(1)
      this.showEiteButton = false
    } else {
      this.showEiteButton = true
      console.log(2)
    }
    console.log(this.showEiteButton)
    this.xzqArray = JSON.parse(localStorage.getItem('xzqEidtArray'))
  },
  methods: {
    readyHandler(map) {
      this.map = map
    },
    addLayer(isPositon) {
      if (this.map) {
        this.map.importLayerGroup.clearLayers()
        if (this.form.dkzb && this.form.dkzb !== '') {
          let highlightLayer
          if (this.form.geojson && this.form.geojson.indexOf('geometry') > -1) {
            highlightLayer = L.geoJSON(JSON.parse(this.form.geojson), { color: 'red', weight: 2, fillColor: 'red', fillOpacity: 0.2 })
          } else {
            highlightLayer = L.geoJSON(JSON.parse(this.form.dkzb), { color: 'red', weight: 2, fillColor: 'red', fillOpacity: 0.2 })
          }

          this.map.importLayerGroup.addLayer(highlightLayer)
          const bounds = this.map.importLayerGroup.getBounds()
          this.map.fitBounds(bounds)
        } else {
          if (isPositon) {
            Notification.warning({
              title: '警告',
              message: '当前地块不存在项目红线...',
              type: 'warning'
            })
          }
        }
      }
    },
    positonhandler() {
      this.addLayer(true)
    },
    // 文件上传限制1个
    handleChangeLimit(fileList) {
      if (fileList.length > 1) {
        Notification.warning({
          title: '提示',
          message: '最多只能上传一张全景图!',
          type: 'warning'
        })
        fileList.splice(1, 1)
      }
    },
    open(id, rowData, name) {
      if (rowData !== undefined) {
        this.form = rowData
        // this.landinfo = rowData
        this.showViewer = false
        this.form.ydxzmc = mapmanager.getYdxzName(this.form.ydxz)
        this.form.xzqmc = xzqUtils.getXZQNAME(this.form.xzq)
        if (this.form.status) {
          const registerType = localStorage.registerType
          if (registerType === '0') {
            if (this.form.status === '已保存') {
              this.tjShow = true
              this.fbShow = false
              this.xjShow = false
            } else {
              this.tjShow = false
              this.fbShow = false
              this.xjShow = false
            }
          } else {
            if (this.form.status === '已保存') {
              this.tjShow = true
              this.fbShow = false
              this.xjShow = false
            } else if (this.form.status === '已提交') {
              this.tjShow = false
              this.fbShow = true
              this.xjShow = false
            } else if (this.form.status === '已发布') {
              this.tjShow = false
              this.fbShow = false
              this.xjShow = true
            } else {
              this.tjShow = false
              this.fbShow = true
              this.xjShow = false
            }
          }
        }
      }
      this.isShow = !this.isShow
      if (id) {
        if (name === '编辑') {
          this.title = name
          this.editFlag = true
        } else {
          this.title = name
          this.editFlag = false
          this.tjShow = false
          this.fbShow = false
          this.xjShow = false
          this.bcShow = false
          this.form.ydxz = this.form.ydxzmc
        }
      } else {
        this.editFlag = true
        this.title = '新增'
      }
      this.all = this.$gcDIC.globalConfigDIC.facilityDic
      if (typeof this.all != 'undefined' && this.all.length > 0) {
        this.tabsActive = this.all[0].id
      }
      if (id) {
        const dkid = id
        const params = {
          id: dkid
        }
        this.queryData(params)
      }
      const _this = this
      setTimeout(() => {
        _this.addLayer()
      }, 600)
    },
    queryData(params) {
      mapResourceApi.getLandInfoAndMatchingById(params).then(response => {
        if (response.code === '200' && response.data) {
          this.landinfo = response.data.landinfo
          this.landinfo.ydxzmc = mapmanager.getYdxzName(this.landinfo.ydxz)
          const mj = this.landinfo.dkmj * 0.0015
          this.dkmj = mj.toFixed(2)
          this.initViewer(this.landinfo.qjt)
          if (this.landinfo.ghfj) {
            const fjArray = this.landinfo.ghfj.split('&')
            for (let index = 0; index < fjArray.length; index++) {
              const ghfjurl = fjArray[index]
              const oject = {}
              if (ghfjurl.indexOf('/virtualPath/GHFJ/') !== -1) {
                oject.url = ghfjurl
                oject.name = ghfjurl.substr(ghfjurl.lastIndexOf('/') + 1, ghfjurl.length - 1)
              } else {
                oject.url = ghfjurl
                oject.name = ghfjurl
              }
              this.ghfjUploadList.push(oject)
            }
          }
          if (this.landinfo.qjt) {
            const qjtArray = this.landinfo.qjt.split('&')
            for (let i = 0; i < qjtArray.length; i++) {
              const qjturl = qjtArray[i]
              const oject = {}
              if (qjturl.indexOf('/virtualPath/QJT/') !== -1) {
                oject.url = qjturl
                oject.name = qjturl.substr(qjturl.lastIndexOf('/') + 1, qjturl.length - 1)
              } else {
                oject.url = qjturl
                oject.name = qjturl
              }

              this.qjtUploadList.push(oject)
            }
          }

          this.photespheremarkerlist = response.data.photespheremarkerlist
          this.all = response.data.list
          this.tableList = this.all[0].children
          for (let i = 0; i < this.all.length; i++) {
            if (this.all[i].id === this.tabsActive) {
              if (this.all[i].resultList) {
                this.tableList = this.all[i].resultList
              } else {
                this.tableList = this.all[i].children
              }
            }
          }
        } else {
          Notification.warning({
            title: '警告',
            message: '获取周边配套信息出错...',
            type: 'warning'
          })
        }
      })
    },
    initViewer(qjt) {
      if (qjt) {
        this.showViewer = true
        this.qjtShow = true
      } else {
        this.qjtShow = false
      }
    },
    tjsubmit() {
      const registerType = localStorage.registerType
      if (registerType === '0') {
        this.$confirm('提交后地块信息不能再修改, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
          // 提交的逻辑
            if (this.form.status) {
              this.form.status = '1'
            }
            this.handin()
          })
      } else {
        this.$confirm('是否提交该地块信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
          // 提交的逻辑
            if (this.form.status) {
              this.form.status = '1'
            }
            this.handin()
          })
      }
    },
    fbsubmit() {
      this.$confirm('是否发布该地块信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 发布的逻辑
          if (this.form.status) {
            this.form.status = '2'
          }
          this.handin()
        })
    },
    xjsubmit() {
      this.$confirm('是否下架该地块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 下架的逻辑
          if (this.form.status) {
            this.form.status = '3'
          }
          this.handin()
        })
    },
    handin() {
      const _this = this
      this.$refs.form.validate(valid => {
        if (valid) {
          if (_this.qjtUploadList.length && _this.qjtUploadList.length > 1) {
            _this.$utils.warning('全景图只能上传一张,请重新选择！')
          } else {
            let text = ''
            if (_this.form.status === '1') {
              text = '提交'
            } else if (_this.form.status === '2') {
              text = '发布'
            } else {
              text = '下架'
            }
            // 全景图地址
            _this.form.qjt = ''
            for (let i = 0; i < _this.qjtUploadList.length; i++) {
              _this.form.qjt += _this.qjtUploadList[i].url + '&'
            }
            _this.form.qjt = _this.form.qjt.substr(0, _this.form.qjt.length - 1)
            // 规划附件地址
            _this.form.ghfj = ''
            for (let i = 0; i < _this.ghfjUploadList.length; i++) {
              _this.form.ghfj += _this.ghfjUploadList[i].url + '&'
            }
            _this.form.ghfj = _this.form.ghfj.substr(0, _this.form.ghfj.length - 1)
            if (typeof _this.form.crnx === 'object') {
              _this.form.crnx = _this.form.crnx.getFullYear()
            }
            if (_this.form.id) {
              const dkId = _this.form.id
              const dkparams = {
                dkId
              }
              mapResourceApi.deleteLandmatching(dkparams).then(res => {
                if (res.code === '200') {
                // _this.$utils.success('删除成功！')
                } else {
                // _this.$utils.error('删除失败！原因是：' + res.msg)
                }
              })
            }
            _this.form.xzq = xzqUtils.getXZQCODE(_this.form.xzqmc)
            // 地块信息添加到数据库
            mapResourceApi.addOrUpdateLandInfo(_this.form).then(res => {
              if (res.code === '200' && res.data) {
                const lndMatchingArr = []
                let lndMatching = {}
                for (let i = 0; i < _this.all.length; i++) {
                  let resultList = []
                  if (this.all[i].resultList) {
                    resultList = this.all[i].resultList
                  } else {
                    resultList = this.all[i].children
                  }
                  if (resultList) {
                    for (let j = 0; j < resultList.length; j++) {
                      lndMatching = {}
                      lndMatching.dkId = res.msg
                      lndMatching.typeId = _this.all[i].id
                      lndMatching.itmename = resultList[j].name
                      lndMatching.orderindex = j
                      lndMatching.coords = resultList[j].location
                      lndMatching.distance = resultList[j].distance
                      lndMatchingArr.push(lndMatching)
                    }
                  }
                }

                if (lndMatchingArr.length > 0) {
                // 地块周边查询结果添加到数据库
                  landinifoApi.addOrUpdateLandMatching(lndMatchingArr).then(res => {
                    if (res.code === '200' && res.data) {
                      _this.$utils.success(text + '成功！')
                      this.$emit('refreshData')
                      this.close()
                    } else {
                      _this.$utils.error(text + '失败！原因是：' + res.msg)
                    }
                  })
                } else {
                  _this.$utils.success(text + '成功！')
                  this.$emit('refreshData')
                  this.close()
                }
              } else {
                _this.$utils.error(text + '失败！原因是：' + res.msg)
              }
            })
          }
        } else {
          _this.$utils.warning('请仔细检查数据格式是否填写正确！')
          return false
        }
      })
    },
    submit() {
      const _this = this
      this.$refs.form.validate(valid => {
        if (valid) {
          if (_this.qjtUploadList.length && _this.qjtUploadList.length > 1) {
            _this.$utils.warning('全景图只能上传一张,请重新选择！')
          } else {
            if (_this.form.status) {
              if (_this.form.status === '已保存') {
                _this.form.status = '0'
              } else if (_this.form.status === '已提交') {
                _this.form.status = '1'
              } else if (_this.form.status === '已发布') {
                _this.form.status = '2'
              } else {
                _this.form.status = '3'
              }
            }
            // 全景图地址
            _this.form.qjt = ''
            for (let i = 0; i < _this.qjtUploadList.length; i++) {
              _this.form.qjt += _this.qjtUploadList[i].url + '&'
            }
            _this.form.qjt = _this.form.qjt.substr(0, _this.form.qjt.length - 1)
            // 规划附件地址
            _this.form.ghfj = ''
            for (let i = 0; i < _this.ghfjUploadList.length; i++) {
              _this.form.ghfj += _this.ghfjUploadList[i].url + '&'
            }
            _this.form.ghfj = _this.form.ghfj.substr(0, _this.form.ghfj.length - 1)
            if (typeof _this.form.crnx === 'object') {
              _this.form.crnx = _this.form.crnx.getFullYear()
            }
            if (_this.form.id) {
              const dkId = _this.form.id
              const dkparams = {
                dkId
              }
              mapResourceApi.deleteLandmatching(dkparams).then(res => {
                if (res.code === '200') {
                // _this.$utils.success('删除成功！')
                } else {
                // _this.$utils.error('删除失败！原因是：' + res.msg)
                }
              })
            }
            _this.form.xzq = xzqUtils.getXZQCODE(_this.form.xzqmc)
            if (this.title == '新增') {
              _this.form.userId = localStorage.userId
              _this.form.sqdw = localStorage.sqdw
            }
            // 地块信息添加到数据库
            mapResourceApi.addOrUpdateLandInfo(_this.form).then(res => {
              if (res.code === '200' && res.data) {
                const lndMatchingArr = []
                let lndMatching = {}
                for (let i = 0; i < _this.all.length; i++) {
                  let resultList = []
                  if (this.all[i].resultList) {
                    resultList = this.all[i].resultList
                  } else {
                    resultList = this.all[i].children
                  }
                  if (resultList) {
                    for (let j = 0; j < resultList.length; j++) {
                      lndMatching = {}
                      lndMatching.dkId = res.msg
                      lndMatching.typeId = _this.all[i].id
                      lndMatching.itmename = resultList[j].name
                      lndMatching.orderindex = j
                      lndMatching.coords = resultList[j].location
                      lndMatching.distance = resultList[j].distance
                      lndMatchingArr.push(lndMatching)
                    }
                  }
                }

                if (lndMatchingArr.length > 0) {
                // 地块周边查询结果添加到数据库
                  landinifoApi.addOrUpdateLandMatching(lndMatchingArr).then(res => {
                    if (res.code === '200' && res.data) {
                      _this.$utils.success('保存成功！')
                      this.$emit('refreshData')
                      this.close()
                    } else {
                      _this.$utils.error('保存失败！原因是：' + res.msg)
                    }
                  })
                } else {
                  _this.$utils.success('保存成功！')
                  this.$emit('refreshData')
                  this.close()
                }
              } else {
                _this.$utils.error('保存失败！原因是：' + res.msg)
              }
            })
          }
        } else {
          _this.$utils.warning('请仔细检查数据格式是否填写正确！')
          return false
        }
      })
    },
    importMapClose() {
      this.showImportmap = false
    },
    plotSubmit() {
      const type = this.$refs.plotpanora.type
      const list = this.$refs.plotpanora.list
      if (list.length === 0) {
        this.$utils.warning('请先绘制一共点！')
        return
      }
      if (type == 1) {
        if (list.length < 2) {
          this.$utils.warning('项目红线不能小于3个点！')
          return
        } else {
          const latlngs = []
          for (let index = 0; index < list.length; index++) {
            const element = list[index]
            latlngs.push(element.latlng)
          }
          this.form.qjtzb = latlngs.join(',')
        }
      } else if (type == 2) {
        if (list.length > 1) {
          this.$utils.warning('项目中心点只能是一个！')
          return
        } else {
          this.form.qjtzxd = list[0].latlng
        }
      } else if (type == 3) {
        const params = []
        for (let i = 0; i < list.length; i++) {
          const element = list[i]
          const object = {}
          object.dkid = this.form.id
          object.bzzb = element.latlng
          object.bzmc = element.name
          params.push(object)
        }
        landinifoApi.addListTphotoSphereMarker(params).then(response => {
          if (response.code === '200') {
            this.$utils.success('保存成功！')
            this.$refs.plotpanora.list = []
            this.$event.$emit('clearmarkersEvent')
          } else {
            this.$utils.warning('数据保存失败！')
          }
        })
        return
      }
      this.submit()
      this.$refs.plotpanora.list = []
      this.$event.$emit('clearmarkersEvent')
    },
    vimportFilemapSubmit() {
      this.form.dkzb = ''
      const checkedFeature = []
      const layer = this.$refs.myimportmap.mainMap.importLayerGroup.getLayers()
      if (layer && layer.length > 0) {
        const layers = layer[0]._layers
        for (const key in layers) {
          if (Object.hasOwnProperty.call(layers, key)) {
            const element = layers[key]
            if (element.feature.checked) {
              checkedFeature.push(element)
            }
          }
        }
      }
      if (checkedFeature.length === 0) {
        this.$utils.warning('请选择一个地块进行导入...')
        return
      }
      const latlngs = []
      for (let i = 0; i < checkedFeature.length; i++) {
        const feature = checkedFeature[i]
        latlngs.push(feature.feature.geometry.coordinates)
      }
      // const polygon = L.polygon(latlngs, {color: 'red'})

      const multiPolygon = turf.multiPolygon(latlngs)
      const highlightLayer = L.geoJSON(multiPolygon, {
        style: { color: 'rgb(255, 0, 0,0.8)' }
      })
      this.map.importLayerGroup.clearLayers()
      this.map.importLayerGroup.addLayer(highlightLayer)
      try {
        const bounds = this.map.importLayerGroup.getBounds()
        this.map.fitBounds(bounds)
      } catch (error) {

      }
      this.showImportmap = false
      this.form.dkzb = JSON.stringify(multiPolygon.geometry)
    },
    close() {
      this.$refs.form.resetFields()
      this.form = {}
      this.qjtUploadList = []
      this.ghfjUploadList = []
      this.isShow = false
      this.tjShow = false
      this.fbShow = false
      this.xjShow = false
      this.bcShow = true
      this.tabsActive = ''
      this.tableList = []
      this.all = []
      // 清空上次查询结果
      for (let i = 0; i < this.$gcDIC.globalConfigDIC.facilityDic.length; i++) {
        this.$gcDIC.globalConfigDIC.facilityDic[i].resultList = []
      }
      // this.$emit('refreshData')
    },
    deletefxjg(id, dkid) {
      if (id) {
        this.$confirm('此操作将永久删除该条记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 删除的逻辑
          const ID = id
          const params = {
            id: ID
          }
          const dkId = dkid
          const param = {
            id: dkId
          }
          landinifoApi.deleteById(params).then(response => {
            if (response.code === '200') {
              this.$utils.success('删除成功！')
              this.queryData(param)
            }
          })
        })
      }
    },
    deletefxjg_linshi(i) {
      if (i != '' || i != undefined) {
        this.$confirm('此操作将永久删除该条记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 删除的逻辑
          this.tableList.splice(i, 1)
          this.$utils.success('删除成功！')
        })
      }
    },
    // 删除文件
    removeFile(fileType, fileTypeId) {
      this[fileType] = {}
      this.form[fileTypeId] = ''
    },
    tabsClick(item) {
      this.tabsActive = item.id
      for (let i = 0; i < this.all.length; i++) {
        if (this.all[i].id === item.id) {
          if (this.all[i].resultList) {
            this.tableList = this.all[i].resultList
          } else {
            this.tableList = this.all[i].children
          }
        }
      }
    },
    analysis() {
      if (this.form.dkzb && this.form.dkzb != '') {
        let geojson = {}
        let feature = {}
        if (this.form.geojson) {
          geojson = this.form.geojson
          feature = JSON.parse(geojson)
        } else {
          const geo = {}
          geo.geometry = JSON.parse(this.form.dkzb)
          feature = geo
        }
        const latlngCenter = mapmanager.getPolygonCenterPoint(feature)
        const gcCenter = coordinatesconvert.wgs84togcj02(Number(latlngCenter[1]), Number(latlngCenter[0]))
        mapsearcharound.analysisGaodeMapAround('', gcCenter, this.queryCallBack)
      } else {
        this.$utils.warning('请先导入地块坐标...')
      }
    },
    queryCallBack(data) {
      if (data.length > 0) {
        this.all = data
        this.tableList = this.all[0].resultList
        console.log(this.tableList)
      } else {
        this.$utils.info('未分析到数据')
      }
    },
    importhandler() {
      this.showImportmap = true
    },
    plottinghandler() {
      this.panoramicViewShow = true
    }
  }
}
</script>
<style lang="scss" scoped>
    .land-form {
        table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;

            tr {
                td {
                    font-size: 16px;
                    color: #333333;
                    border: 1px solid #dddddd;
                    padding: 6px 10px;
                    line-height: 32px;
                    >span{
                        line-height: 21px;
                        display: inline-block;
                    }
                    .upload-button-left {
                        margin-right: 10px;

                        ::v-deep {
                            .el-button.el-button--small, .el-button--small.is-round {
                                font-size: 14px;
                                padding: 8px 15px;

                                i.iconfont {
                                    font-size: 14px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }

                    .el-button.el-button--small, .el-button--small.is-round {
                        font-size: 14px;
                        padding: 8px 15px;

                        i.iconfont {
                            font-size: 14px;
                            margin-right: 5px;
                        }
                    }

                    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
                        margin-bottom: 0px;
                    }

                    .el-date-editor.el-input, .el-date-editor.el-input__inner {
                        width: 100%;
                    }

                    &:nth-child(even) {
                        background: #fff;
                    }

                    &:nth-child(odd) {
                        background: #f5f6f8;
                        text-align: right;
                    }

                    &.header {
                        height: 40px;
                        background: #f0f6fa;
                        padding: 0px 10px;
                        text-align: left;
                        font-weight: bold;
                    }

                    .img-list {
                        position: relative;
                        width: 124px;
                        height: 71px;
                        margin-right: 10px;
                        display: inline-block;
                        vertical-align: middle;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                        .img-detele {
                            position: absolute;
                            bottom: 0px;
                            width: 100%;
                            height: 20px;
                            background: rgba(0, 0, 0, 0.5);
                            line-height: 20px;
                            color: #fff;
                            text-align: center;
                            cursor: pointer;
                        }
                    }

                    .add-img {
                        cursor: pointer;
                        display: inline-block;
                        vertical-align: middle;
                        ::v-deep {
                            > div {
                                line-height: normal;
                                .el-upload-dragger {
                                    height: 100%;
                                    width: 100%;
                                    font-size: 14px;
                                    color: #666666;
                                    padding: 5px 0px 4px;
                                    width: 124px;
                                    height: 71px;
                                    .el-icon-upload {
                                        color: #2f77f1;
                                        font-size: 22px;
                                        margin: 0px;
                                        line-height: 20px;
                                    }
                                }
                                .el-upload-list__item{
                                    transition: none !important;
                                }
                            }
                        }
                    }
                    .qt-upload{
                        ::v-deep {
                            > div {
                                .el-upload-list__item{
                                    transition: none !important;
                                }
                            }
                        }
                    }
                    .tabs {
                        .tabs-label {
                            display: flex;
                            justify-content: center;
                            padding: 0px 20px;
                            background: #f5f6f8;
                            height: 47px;
                            line-height: 47px;
                            padding-top: 5px;
                            border-bottom: 1px solid #ddd;

                            > div {
                                width: calc(100% / 6);
                                text-align: center;
                                height: 43px;
                                line-height: 43px;
                                cursor: pointer;
                                border: 1px solid transparent;

                                &.active {
                                    background: #fff;
                                    border-right: 1px solid #ddd;
                                    border-left: 1px solid #ddd;
                                    border-top: 1px solid #ddd;
                                    border-bottom: 1px solid #fff;
                                }
                            }
                        }

                        .tabs-content {
                            padding: 20px;
                            text-align: left;

                            .el-button {
                                margin-bottom: 10px;
                            }

                            table {
                                width: 100%;

                                th {
                                    height: 40px;
                                    background: #f8f8f9;
                                    font-size: 16px;
                                    font-weight: 600;
                                    color: #515a6e;
                                    text-align: left;

                                    &:first-child {
                                        text-align: center;
                                    }
                                }

                                td {
                                    height: 48px;
                                    background: #ffffff;
                                    font-size: 16px;
                                    font-weight: 400;
                                    color: #333333;
                                    text-align: left;
                                    border: none;
                                    border-bottom: 1px solid #ddd;

                                    &:first-child {
                                        text-align: center;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .el-select {
            width: 100%;
            ::v-deep {
                .el-input-number {
                    .el-input__inner {
                        text-align: left;
                    }
                }
            }
        }
    }
</style>
